import React from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'edit-underline-icon';

const originalDimensions = {
    width: 24,
    height: 24,
};

export const IconEditUnderline = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses } = props;
    const classNames = cx(addClasses, 'inline');

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Edit Icon with Underline</title>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M19.925 8.44l-8.449 8.448a1.5 1.5 0 01-1.075.44l-3.523-.035a1.5 1.5 0 01-1.485-1.463l-.086-3.427a1.5 1.5 0 01.439-1.098l8.522-8.522a1.5 1.5 0 012.121 0l3.536 3.535a1.5 1.5 0 010 2.121z"
                    fill={fill}
                    fillRule="nonzero"
                />
                <rect
                    fill={fill}
                    opacity=".3"
                    x="5"
                    y="20"
                    width="15"
                    height="2"
                    rx="1"
                />
            </g>
        </svg>
    );
};
